import { useParams } from 'react-router-dom'
import { usePreferences } from 'context/preferences/PreferencesContext'
import { ContactCompanyType } from 'models/contact_companies'
import { getIdWithPrefix } from 'utils/pathUtils'
import { useGetUniversity } from 'services/universities'
import LoadingScreen from 'components/Layout/LoadingScreen'
import useDocumentTitle from 'components/useDocumentTitle'
import {
  MobileCompanyPageShell,
  MobileCompanyNotFound,
} from 'components/MobileCompanyPage/MobileCompanyPageShell'
import { buildUniversityPageContent } from './companyTypeData'

export function MobileUniversityPage() {
  const urlParams = useParams()
  const { preferences } = usePreferences()
  const universityID = urlParams?.university_name
    ? getIdWithPrefix(
        urlParams.university_name,
        preferences?.company_type_prefix_map[ContactCompanyType.University]
      )
    : undefined

  const { data, isLoading } = useGetUniversity(universityID)

  // Shared derivation — same stats/fields as the desktop NewUniversityPage.
  const content = buildUniversityPageContent(data)
  useDocumentTitle(isLoading ? 'Loading...' : content.documentTitle)

  if (isLoading) {
    return <LoadingScreen />
  }

  if (!data || !content.contactCompanyId) {
    return <MobileCompanyNotFound label="University not found" />
  }

  return (
    <MobileCompanyPageShell
      contactCompanyId={content.contactCompanyId}
      companyName={content.header.name}
      domain={content.header.domain}
      summaryContent={content.summaryContent}
      locationDetailsContent={content.locationDetailsContent}
    />
  )
}
